<template>
  <v-container>
      <v-row justify="center" alignment="center">
          <v-col cols="auto" class="text-green mid-size" v-html="introText">
          </v-col>
      </v-row>
  </v-container>
</template>

<script>
  export default {
    props: ['langData'],
    data: (el = this) => ({
      name : 'receipt',
      heading: el.langData.receipt.title,
      introText: el.langData.receipt.body,
      lashesRight : {src:require('../assets/lashesRight.png')},
      lashesLeft : {src:require('../assets/lashesLeft.png')},
      lashHeight: '54px',
    })
  }
</script>